var map = {
	"./1.mp4": "4STV",
	"./404_1044.vid_4.mp4": "VQ3w",
	"./Change-This1.png": "fBfB",
	"./ShoppingCart.mp4": "uA0r",
	"./animacja.gif": "XTQ+",
	"./animacja.webm": "hP7w",
	"./bg-cuna-sportswear.png": "IBZy",
	"./bg-mercedes.jpg": "Kwpb",
	"./brilliant-bg1-1x.jpg": "3Ei6",
	"./brilliant-bg1-2x.jpg": "woOx",
	"./brilliant-bg2-1x.jpg": "LGLO",
	"./brilliant-bg2-2x.jpg": "gZYW",
	"./brilliant-brain-1x.png": "zp3V",
	"./brilliant-brain-2x.png": "mUb0",
	"./brilliant-circles.svg": "SbQ6",
	"./brilliant-circles1-1x.png": "zWaE",
	"./brilliant-circles1-2x.png": "62ej",
	"./brilliant-laptop-1x.png": "7Mvt",
	"./brilliant-laptop-2x.png": "qmSN",
	"./brilliant-plant1-1x.png": "IE90",
	"./brilliant-plant1-2x.png": "juu5",
	"./brilliant-screen1-2x.jpg": "IqPR",
	"./brilliant-screen2-1x.jpg": "5d3w",
	"./brilliant-screen2-2x.jpg": "ssDQ",
	"./brilliant-screen3-1x.jpg": "jnv5",
	"./brilliant-screen3-2x.jpg": "TE+h",
	"./brilliant-screen4-1x.jpg": "ullt",
	"./brilliant-screen4-2x.jpg": "zb6u",
	"./brilliant-screen5-1x.jpg": "i1Cy",
	"./brilliant-screen5-2x.jpg": "6HHu",
	"./brilliant-watch-1x.png": "b5iZ",
	"./brilliant-watch-2x.png": "+AIv",
	"./brilliantbg.jpg": "roKl",
	"./brilliantfox.png": "YgKZ",
	"./buildpizzadark_444.mp4": "QVQJ",
	"./car_mercedes_1.png": "3OcR",
	"./car_mercedes_2.png": "ofz9",
	"./cloud.png": "5Ax4",
	"./contact-bg.png": "lt5a",
	"./dominos-assets/apple.png": "5hao",
	"./dominos-assets/apple@2x.png": "QsmR",
	"./dominos-assets/apple@3x.png": "ri9f",
	"./dominos-assets/iphone-pizza.png": "HYx3",
	"./dominos-assets/leaf1.png": "z2bm",
	"./dominos-assets/leaf1@2x.png": "6Asj",
	"./dominos-assets/leaf1@3x.png": "USnz",
	"./dominos-assets/leaf2.png": "cRYZ",
	"./dominos-assets/leaf2@2x.png": "4Rln",
	"./dominos-assets/leaf2@3x.png": "DtFf",
	"./dominos-assets/leaf3.png": "mOfe",
	"./dominos-assets/leaf3@2x.png": "6RAt",
	"./dominos-assets/leaf3@3x.png": "o3Ks",
	"./dominos-assets/leaf4.png": "H5JP",
	"./dominos-assets/leaf4@2x.png": "K3Uy",
	"./dominos-assets/leaf4@3x.png": "gUKG",
	"./dominos-assets/leaf5.png": "T7mG",
	"./dominos-assets/leaf5@2x.png": "ilwT",
	"./dominos-assets/leaf5@3x.png": "46i/",
	"./dominos-assets/pizza_listki.png": "OWeH",
	"./dominos-bg-2x.png": "yI7V",
	"./dominos-bg2.jpg": "mOzN",
	"./dominos-bg3-1x.jpg": "C1st",
	"./dominos-bg3-2x.jpg": "RtEX",
	"./dominos-dostawca.png": "lE4O",
	"./dominos-logo-1x.png": "4rvE",
	"./dominos-logo-2x.png": "+TsD",
	"./dominos-pizza-slice.png": "DjqJ",
	"./dominos-screen1-1x.jpg": "WPp1",
	"./dominos-screen1-2x.jpg": "Nkff",
	"./dominos-screen1-2x.png": "bosO",
	"./dominos-screen2-1x.jpg": "7BM9",
	"./dominos-screen2-2x.jpg": "bLLo",
	"./dominos-screen3-1x.jpg": "7wda",
	"./dominos-screen3-2x.jpg": "M2lO",
	"./dominos-screen4-2x.png": "PcIn",
	"./font-gilroy/Gilroy-ExtraBold.woff": "pKPt",
	"./font-gilroy/Gilroy-ExtraBold.woff2": "hIQR",
	"./font-gilroy/Gilroy-Light.woff": "K3WM",
	"./font-gilroy/Gilroy-Light.woff2": "C6i4",
	"./font-gilroy/Gilroy-Medium.woff": "njLM",
	"./font-gilroy/Gilroy-Medium.woff2": "GiI5",
	"./funkcjonalnoscaplikacji.mp4": "mKv4",
	"./icon-play.svg": "4HFS",
	"./icons_nykart.png": "8ANV",
	"./internet-global.svg": "P/jG",
	"./intervi-dark.svg": "8p1v",
	"./intervi-light.svg": "9jN6",
	"./lisc1.png": "Kip0",
	"./lisc2.png": "QchL",
	"./matthias-steak.jpg": "XCFo",
	"./mercedes-bg-1x.jpg": "/9q/",
	"./mercedes-bg-2x.jpg": "vMIp",
	"./mercedes-bg2-1x.png": "zkgR",
	"./mercedes-circle-basic.svg": "QhTD",
	"./mercedes-circle.png": "QOuv",
	"./mercedes-circles-light.png": "Vtez",
	"./mercedes-circles-light.svg": "TOvQ",
	"./mercedes-circles.svg": "6rwV",
	"./mercedes-dots1-1x.png": "CkZf",
	"./mercedes-dots1-2x.png": "33uv",
	"./mercedes-hand1-1x.png": "d2QC",
	"./mercedes-hand1-2x.png": "txw5",
	"./mercedes-onedot.svg": "51Mp",
	"./mercedes-screen1-1x.png": "AsNo",
	"./mercedes-screen2-1x.png": "7D3D",
	"./mercedes-screen3cut-1x.png": "oEkw",
	"./mercedes-screen4-1x.png": "Xqx+",
	"./mercedes.png": "cdS4",
	"./monsterki-animacja.gif": "ak89",
	"./monsters.png": "5r+v",
	"./mouse-3.svg": "HmN/",
	"./nykart-bg1-1x.jpg": "Xigm",
	"./nykart-bg1-2x.jpg": "YYlO",
	"./nykart-bg2-1x.jpg": "Gqls",
	"./nykart-bg2-2x.jpg": "NuRn",
	"./nykart-bg3-1x.jpg": "d8ry",
	"./nykart-bg3-2x.jpg": "rlVR",
	"./nykart-bg4-1x.jpg": "8KKN",
	"./nykart-bg4-2x.jpg": "F6s7",
	"./nykart-bg5-1x.jpg": "jnQ0",
	"./nykart-bg5-2x.jpg": "2s8E",
	"./nykart-bg6-1x.jpg": "Xvws",
	"./nykart-bg6-2x.jpg": "iecH",
	"./nykart-bike1-1x.jpg": "Lfd9",
	"./nykart-bike1-2x.jpg": "BgZn",
	"./nykart-chair1-1x.png": "6QtD",
	"./nykart-chair1-2x.png": "4YMf",
	"./nykart-chair2-1x.png": "qdgh",
	"./nykart-chair2-2x.png": "vgoV",
	"./nykart-logoblack1-1x.png": "HgV6",
	"./nykart-logoblack1-2x.png": "PpXA",
	"./nykart-logogray1-1x.png": "wPdu",
	"./nykart-logogray1-2x.png": "EbL3",
	"./nykart-logowhite1-1x.png": "wAjg",
	"./nykart-logowhite1-2x.png": "S3nk",
	"./nykart-monitor1-1x.png": "8+Be",
	"./nykart-monitor1-2x.png": "QnSD",
	"./nykart-pillow1-1x.png": "W3Rh",
	"./nykart-pillow1-2x.png": "JcEX",
	"./nykart-pillow2-1x.png": "Dfng",
	"./nykart-pillow2-2x.png": "muQN",
	"./nykart-plant1-1x.png": "Tb93",
	"./nykart-plant1-2x.png": "6F26",
	"./nykart-plant2-1x.png": "Rgui",
	"./nykart-plant2-2x.png": "fG6Z",
	"./nykart-plant3-1x.png": "wvT3",
	"./nykart-plant3-2x.png": "DOQM",
	"./nykart-screen1-1x.jpg": "sYh/",
	"./nykart-screen1-2x.jpg": "5vNS",
	"./nykart-screen2-1x.png": "dlEA",
	"./nykart-screen2-2x.png": "egBD",
	"./nykart-screen21-1x.png": "Qh5f",
	"./nykart-screen21-2x.png": "xw6L",
	"./nykart-screen22-1x.png": "R9WD",
	"./nykart-screen22-2x.png": "KMdT",
	"./nykart-screen3-1x.jpg": "xBA7",
	"./nykart-screen3-2x.jpg": "XcUe",
	"./nykart-screen4-1x.jpg": "gv94",
	"./nykart-screen4-2x.jpg": "NelP",
	"./nykart-wood1-1x.png": "rY1R",
	"./nykart-wood1-2x.png": "h8Bd",
	"./people": "AF8K",
	"./people.js": "AF8K",
	"./person1.png": "0V7U",
	"./person2.png": "v3jR",
	"./person3.png": "Nf4B",
	"./persons/intervi-1.jpg": "/tlI",
	"./persons/intervi-10.jpg": "D/co",
	"./persons/intervi-11.jpg": "BnHv",
	"./persons/intervi-12.jpg": "0gcd",
	"./persons/intervi-13.jpg": "c40n",
	"./persons/intervi-14.jpg": "7y4b",
	"./persons/intervi-2.jpg": "SmMZ",
	"./persons/intervi-3.jpg": "UZIl",
	"./persons/intervi-4.jpg": "6IPK",
	"./persons/intervi-5.jpg": "2ik7",
	"./persons/intervi-6.jpg": "mH/K",
	"./persons/intervi-7.jpg": "9uxe",
	"./persons/intervi-9.jpg": "mpF5",
	"./phone-hand.png": "xOtP",
	"./phone1.png": "vh9e",
	"./phone2-cutted.png": "n4G1",
	"./phone2.png": "3zUX",
	"./pizzashot.mp4": "7Yd6",
	"./project-logos/bitmap.png": "/VMS",
	"./project-logos/bitmap@2x.png": "PU+y",
	"./project-logos/bitmap@3x.png": "A0Kq",
	"./project-logos/dominos-logo-2x.png": "uBiY",
	"./project-logos/dominos_logo.svg": "Vp0R",
	"./project-logos/janczaki-logo.svg": "LBcr",
	"./project-logos/logo.png": "vyqT",
	"./project-logos/logo.svg": "GlFR",
	"./project-logos/logo@2x.png": "lMB4",
	"./project-logos/logo@3x.png": "FkQY",
	"./project-logos/matthias-logo.svg": "p2AP",
	"./project-logos/page-1.png": "bHWB",
	"./project-logos/page-1.svg": "5cGh",
	"./project-logos/page-1@2x.png": "kzpt",
	"./project-logos/page-1@3x.png": "xrHu",
	"./project-logos/pizzabox_logo_sygnet.svg": "yNQU",
	"./projects": "haCu",
	"./projects.js": "haCu",
	"./signature.png": "Tujo",
	"./slider-intervi1.jpg": "ZMYh",
	"./social-icons1-1x.png": "RM+G",
	"./social-icons1-2x.png": "Hry4",
	"./social1-1x.jpg": "PPUU",
	"./social1-2x.jpg": "B6T1",
	"./social10-1x.png": "PCqO",
	"./social10-2x.png": "inmg",
	"./social2-1x.jpg": "eqcj",
	"./social2-2x.jpg": "fM8u",
	"./social3-1x.jpg": "B4UD",
	"./social3-2x.jpg": "WJ2O",
	"./social4-1x.jpg": "A/oN",
	"./social4-2x.jpg": "bSYt",
	"./social5-1x.jpg": "9aer",
	"./social5-2x.jpg": "Il22",
	"./social6-1x.jpg": "0STl",
	"./social6-2x.jpg": "QwAv",
	"./social7-1x.jpg": "jIhS",
	"./social7-2x.jpg": "wP/c",
	"./social8-1x.jpg": "eJsa",
	"./social8-2x.jpg": "55X8",
	"./social9-1x.png": "/97R",
	"./social9-2x.png": "MaPY",
	"./table_nykart.png": "ZHIQ",
	"./test.svg": "SC2M",
	"./trees.png": "dTUi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 0